import { Component, Input, OnInit } from "@angular/core";
import { IconName } from "app/shared/models/icon-name.type";
import { IconSize } from "app/shared/models/icon-size.type";
import { NgClass, NgIf } from "@angular/common";
import { SvgComponent } from "app/shared/components/svg/svg-icon/svg-icon.component";

@Component({
  selector: "svg-wrapper",
  templateUrl: "./svg-wrapper.component.html",
  styleUrls: ["./svg-wrapper.component.scss"],
  imports: [NgClass, SvgComponent, NgIf],
})
export class SvgWrapperComponent implements OnInit {
  @Input() public bgColor: string = "svg-wrapper--bg";
  @Input() public buttonBorder: string = "";
  @Input() public iconColor: string = "";
  @Input() public iconName: IconName;
  @Input() public initials: string;
  @Input() public size: string;
  @Input() public e2e: string;

  public iconSize: IconSize = "";

  public calculateClasses(): string {
    switch (this.size) {
      case "button-size":
        this.iconSize = this.size;
        break;
      case "medium":
        this.iconSize = "small";
        break;
      case "large":
        this.iconSize = "medium";
        break;
      case "x-large":
        this.iconSize = "large";
        break;
      case "upper-x-large":
        this.iconSize = "upper-x-large";
        break;
      case "x-large--floating-window":
        this.iconSize = "x-large--floating-window";
        break;
      case "xx-large":
        this.iconSize = "x-large";
        break;
      case "small":
        this.iconSize = "xs";
        break;
      default:
        this.size = "";
    }

    return this.size;
  }

  public ngOnInit(): void {
    this.calculateClasses();
  }
}
